import React, { useState, useEffect } from "react";
import styles from "./ProductsComponent.module.css";
import AddProduct from "./AddProduct";
import { Product } from "../../../interface/product";
import { Series } from "../../../interface/series";
import { getAllSeries } from "../../../service/series";
import { deleteProduct, getAllProducts } from "../../../service/product";

const ProductsComponent = () => {
  const [products, setProducts] = useState([]);
  const [series, setSeries] = useState<Series[]>([]);
  const [selectedSeriesId, setSelectedSeriesId] = useState("");
  const [showAddForm, setShowAddForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editingProduct, setEditingProduct] = useState<Product | null>(null);

  const fetchSeries = async () => {
    try {
      const data = await getAllSeries();
      setSeries(data);
      if (data.length > 0 && !selectedSeriesId) {
        setSelectedSeriesId(data[0].id);
      }
    } catch (err: any) {
      setError(err.message || "Failed to fetch series");
    }
  };

  const fetchProducts = async () => {
    try {
      setLoading(true);
      setError("");
      const data = await getAllProducts(selectedSeriesId);
      setProducts(data?.products);
    } catch (err: any) {
      setError(err.message || "Failed to fetch products");
    } finally {
      setLoading(false);
    }
  };
  const handleDelete = async (id: string) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      try {
        await deleteProduct(id);
        fetchProducts();
      } catch (err: any) {
        setError(err.message || "Failed to delete product");
      }
    }
  };

  const handleEdit = (product: Product) => {
    setEditingProduct(product);
    setShowAddForm(true);
  };

  useEffect(() => {
    fetchSeries();
  }, []);

  useEffect(() => {
    if (selectedSeriesId) {
      fetchProducts();
    }
  }, [selectedSeriesId]);

  return (
    <div className={styles.productsContainer}>
      <div className={styles.headerRow}>
        <h2 className={styles.sectionTitle}>Products</h2>
        <button
          className={styles.addButton}
          onClick={() => {
            setEditingProduct(null);
            setShowAddForm(!showAddForm);
          }}
        >
          {showAddForm ? "Cancel" : "Add New Product"}
        </button>
      </div>
      <div className={styles.filters}>
        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>Filter by Series:</label>
          <select
            value={selectedSeriesId}
            onChange={(e) => setSelectedSeriesId(e.target.value)}
            className={styles.filterSelect}
          >
            {series?.map((s: any) => (
              <option key={s?.id} value={s?.id}>
                {s?.title}
              </option>
            ))}
          </select>
        </div>
      </div>
      {showAddForm && (
        <div className={styles.formContainer}>
          <AddProduct
            onSuccess={() => {
              fetchProducts();
              setShowAddForm(false);
            }}
            initialData={editingProduct}
          />
        </div>
      )}
      {error && <div className={styles.error}>{error}</div>}
      {/* {loading ? (
        <div className={styles.loading}>Loading products...</div>
      ) : products?.length === 0 ? (
        <div className={styles.noResults}>
          No products found for this series
        </div>
      ) : (
        <div className={styles.tableContainer}>
          <table className={styles.productsTable}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Color</th>
                <th>Price</th>
                <th>Our Price</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {
                // @ts-ignore
                products?.map((p: any) => (
                  // @ts-ignore
                  <tr key={p?._id}>
                    <td>{p?.productId}</td>
                    <td>{p?.name}</td>
                    <td>{p?.color}</td>
                    <td>₹{p?.price?.toFixed(2)}</td>
                    <td>₹{p?.ourPrice?.toFixed(2)}</td>
                    <td className={styles.actionsCell}>
                      <button
                        className={styles.editButton}
                        onClick={() => handleEdit(p)}
                      >
                        Edit
                      </button>
                      <button
                        className={styles.deleteButton}
                        onClick={() => handleDelete(p?._id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      )} */}

      {loading ? (
        <div className={styles.loading}>Loading products...</div>
      ) : !Array.isArray(products) || products.length === 0 ? (
        <div className={styles.noResults}>
          {error ? error : "No products found for this series"}
        </div>
      ) : (
        <div className={styles.tableContainer}>
          <table className={styles.productsTable}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Color</th>
                <th>Price</th>
                <th>Our Price</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {products.map((p: Product) => (
                <tr key={p._id}>
                  <td>{p.productId}</td>
                  <td>{p.name}</td>
                  <td>{p.color}</td>
                  <td>₹{p.price?.toFixed(2)}</td>
                  <td>₹{p.ourPrice?.toFixed(2)}</td>
                  <td className={styles.actionsCell}>
                    <button
                      className={styles.editButton}
                      onClick={() => handleEdit(p)}
                    >
                      Edit
                    </button>
                    <button
                      className={styles.deleteButton}
                      onClick={() => handleDelete(p._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ProductsComponent;
